import { render, staticRenderFns } from "./portData.vue?vue&type=template&id=73dc71a6&scoped=true"
import script from "./portData.vue?vue&type=script&lang=js"
export * from "./portData.vue?vue&type=script&lang=js"
import style0 from "./portData.vue?vue&type=style&index=0&id=73dc71a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc71a6",
  null
  
)

export default component.exports